exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".processing-error-cell[data-v-29f2fd2d]{max-width:200px;white-space:normal;word-wrap:break-word;overflow-wrap:break-word}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-29f2fd2d","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/xmlimport/history.vue
// module id = 879
// module chunks = 0